// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/organizations/types/organizations.types.ts
export enum EShortcutDestinationType {
  FOLDER = 'FOLDER',
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  NONE = 'NONE', // shown in the rail for demos, opens nothing
}

export type TShortcut = {
  destinationType: EShortcutDestinationType;
  destination?: string;
};

export type TOrganizationShortcuts = {
  TD?: TShortcut;
  QMS?: TShortcut;
};
